import { dataTrackingLog } from "../core/utils";
import type { EventContext } from "../types";

/**
 * Pushes an ecommerce tracking event to the appropriate dataLayer and logs the payload.
 *
 * Ensures a dataLayer array exists on the target (prefer `ecomm.window` if present, otherwise the global `window`)
 * and pushes an object containing `event` and the `ecomm` payload. Also logs the pushed payload for debugging.
 *
 * @param event - The tracking event name to push
 * @param ecomm - The ecommerce event context payload; if it contains a `window` property that object's `dataLayer` will be used as the target
 * @param dest - A destination label used by the logger
 */
export function pushToDataLayer(event: string, ecomm: EventContext, dest: string) {
  const targetWindow = ecomm.window;
  const ecommercePayload = Object.assign({}, ecomm);
  delete ecommercePayload.window; // delete window prop and avoid to push as payload to dayalayer

  dataTrackingLog({ event: event, ecommerce: ecommercePayload }, '#0b5fff', dest);

  if (targetWindow) {
    targetWindow.dataLayer = targetWindow.dataLayer || [];
    targetWindow.dataLayer.push({ event: event, ecommerce: ecommercePayload });
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: event, ecommerce: ecommercePayload });
}